import React, { useMemo } from 'react'
import { BarList, C } from './AdminAnalyticsUI';

// Reports grouped by reason (was a pie chart)
function ReportsReasonGraph({data}) {
  const items = useMemo(() => {
    const counts = {};
    data?.reported?.forEach((r) => {
      const key = r?.reported?.reason || 'No reason given';
      counts[key] = (counts[key] || 0) + 1;
    });
    return Object.entries(counts).map(([label, value]) => ({ label, value }));
  }, [data]);
  return <BarList items={items} color={C.red} emptyText="No reports in this range" />;
}

export default ReportsReasonGraph;
